/**
 * BoardV3 Selection Overlay
 * Blue rectangle drawn during rubber-band selection
 */

import { memo } from 'react';

interface BoardV3SelectionOverlayProps {
  rect: { x: number; y: number; width: number; height: number };
}

export const BoardV3SelectionOverlay = memo(function BoardV3SelectionOverlay({
  rect,
}: BoardV3SelectionOverlayProps) {
  return (
    <div
      style={{
        position: 'absolute',
        left: rect.x,
        top: rect.y,
        width: rect.width,
        height: rect.height,
        backgroundColor: 'rgba(59, 130, 246, 0.08)',
        border: '1px solid rgba(59, 130, 246, 0.4)',
        pointerEvents: 'none',
        zIndex: 10,
      }}
    />
  );
});
